var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "task_QRCode" } },
    [
      _c(
        "Modal",
        {
          attrs: {
            title: "报名二维码",
            styles: {
              top: "60px",
              "max-height": "400px",
              "overflow-y": "auto",
            },
            "mask-closable": false,
          },
          model: {
            value: _vm.QRCodeWindow,
            callback: function ($$v) {
              _vm.QRCodeWindow = $$v
            },
            expression: "QRCodeWindow",
          },
        },
        [
          _c(
            "table",
            {
              staticClass: "container",
              staticStyle: { "text-align": "center" },
              attrs: {
                id: "qrCodePrint",
                cellspacing: "0",
                cellpadding: "0",
                align: "center",
              },
            },
            [
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "18px",
                        },
                      },
                      [_vm._v(_vm._s(_vm.edit.name))]
                    ),
                  ]),
                ]),
                _c("tr", [
                  _c("td", [
                    _c("img", {
                      staticStyle: { width: "180px", height: "180px" },
                      attrs: { src: _vm.edit.wxCodeUrl },
                    }),
                  ]),
                ]),
                _c("tr", [
                  _c("td", { staticStyle: { "font-size": "18px" } }, [
                    _vm._v(
                      "有效期: " +
                        _vm._s(_vm.edit.signUpStartDate) +
                        " 至 " +
                        _vm._s(_vm.edit.signUpEndDate)
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "print",
                      rawName: "v-print",
                      value: _vm.printContent,
                      expression: "printContent",
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { id: "print" },
                },
                [_vm._v("打印")]
              ),
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.QRCodeWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.print } },
                [_vm._v("打印")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }